import { createFileRoute, notFound, redirect } from "@tanstack/react-router"

import { logger } from "@repo/utils/logger"
import {
  getExtendedBusinessEntitiesQueryOptions,
  getExtendedBusinessEntityQueryOptions,
} from "~/modules/business-entities/business-entities.queries"
import { BusinessEntityLayout } from "~/modules/business-entities/components/business-entity-layout"
import { useFeatureConfigs } from "~/modules/system-config/hooks/use-feature-configs"

const log = logger.child({
  module: "business-entities-route",
})

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/business-entities/$businessEntitySlug",
)({
  component: RouteComponent,
  beforeLoad: async ({ location, params, search }) => {
    // Redirect to the overview route if this naked route is accessed directly
    if (
      location.pathname === `/business-entities/${params.businessEntitySlug}`
    ) {
      throw redirect({
        to: "./overview",
        from: "/business-entities/$businessEntitySlug",
        params,
        search,
      })
    }
  },
  loader: async ({ context, params }) => {
    context.queryClient
      .ensureQueryData(getExtendedBusinessEntitiesQueryOptions())
      .catch((error) => {
        log.error("Error getting extended business entities", { error })
        return null
      })
    context.queryClient
      .ensureQueryData(
        getExtendedBusinessEntityQueryOptions({
          businessEntitySlug: params.businessEntitySlug,
        }),
      )
      .catch((error) => {
        log.error("Error getting extended business entity", { error })
        return null
      })
  },
})

function RouteComponent() {
  const { isBusinessEntityManagementOn } = useFeatureConfigs()
  const { businessEntitySlug } = Route.useParams()

  if (!isBusinessEntityManagementOn) {
    throw notFound()
  }

  return <BusinessEntityLayout businessEntitySlug={businessEntitySlug} />
}
